import { c as _c } from "react/compiler-runtime";
import { IcoChevronLeft16 } from '@onefootprint/icons';
import type React from 'react';
type ContainerWithToggleProps = {
  isHidden: boolean;
  onChangeHidden: (hidden: boolean) => void;
  children: React.ReactNode;
};
const ContainerWithToggle = t0 => {
  const $ = _c(15);
  const {
    isHidden,
    onChangeHidden,
    children
  } = t0;
  let t1;
  if ($[0] !== isHidden || $[1] !== onChangeHidden) {
    t1 = () => onChangeHidden(!isHidden);
    $[0] = isHidden;
    $[1] = onChangeHidden;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = !isHidden;
  const t3 = isHidden ? "Show details panel" : "Hide details panel";
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <IcoChevronLeft16 />;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== isHidden || $[5] !== t1 || $[6] !== t2 || $[7] !== t3) {
    t5 = <button type="button" className="flex w-[26px] h-8 justify-center items-center absolute top-4 -right-[26px] rounded-r bg-primary border border-tertiary p-1 cursor-pointer shadow-[0px_1px_4px_0px_rgba(0,0,0,0.12)] max-md:hidden data-[hidden=true]:[&_svg]:scale-x-[-1]" data-hidden={isHidden} onClick={t1} aria-expanded={t2} aria-label={t3}>{t4}</button>;
    $[4] = isHidden;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== children || $[10] !== t5) {
    t6 = <div className="w-full h-full bg-primary p-3 pt-3 pr-3 pl-3 overflow-hidden -mr-[35px] flex flex-col rounded-sm rounded-l max-md:rounded-sm">{children}{t5}</div>;
    $[9] = children;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== isHidden || $[13] !== t6) {
    t7 = <div className="relative flex-1 min-h-0 md:absolute md:top-0 md:left-0 w-[428px] h-full z-sticky border-r border-tertiary rounded-sm rounded-l transition-transform duration-300 ease-in-out shadow-elevation-1 max-md:w-full max-md:rounded max-md:border-r-0 max-md:shadow-none data-[hidden=true]:-translate-x-full data-[hidden=true]:shadow-none data-[hidden=true]:border-r-0" data-hidden={isHidden}>{t6}</div>;
    $[12] = isHidden;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};
export default ContainerWithToggle;